export const styles = {
  musicNoteImageMainContainer: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
  } as const,
  musicNoteImageContainer: {
    display: "flex",
    border: "1px solid gray",
    padding: "10px",
    borderRadius: "10px",
    width: "50px",
    marginBottom: "10px",
  } as const,
};
